import { Directive, ComponentFactoryResolver, ViewContainerRef, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormItem } from './FormItem';
import { FieldTypes } from '../../FieldTypes';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';
import { ButtonComponent } from '../button/button.component';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { DatepickerComponent } from '../datepicker/datepicker.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { InputComponent } from '../input/input.component';
import { RadioComponent } from '../radio/radio.component';
import { Form, FormGroup } from '@angular/forms';
import { FileComponent } from '../file/file.component';
import { ImgComponent } from '../img/img.component';
import { TableComponent } from '../table/table.component';
import { PageViewerComponent } from '../page-viewer/page-viewer.component';

const fieldMatcher = {
  autocomplete: AutocompleteComponent,
  button: ButtonComponent,
  submit: ButtonComponent,
  checkbox: CheckboxComponent,
  datepicker: DatepickerComponent,
  combobox: DropdownComponent,
  dropdown: DropdownComponent,
  text: InputComponent,
  number: InputComponent,
  email: InputComponent,
  file: FileComponent,
  img: ImgComponent,
  password: InputComponent,
  radio: RadioComponent,
  table: TableComponent,
  pageviwer: PageViewerComponent,
};

@Directive({
  selector: '[viasFormItem]'
})
export class FormItemDirective implements OnInit {
  @Input() item: FormItem;
  @Input() form: FormGroup;
  @Output() itemClick: EventEmitter<FormItem> = new EventEmitter<FormItem>();
  componentRef: any;

  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) { }
  ngOnInit(): void {
    const factory = this.resolver.resolveComponentFactory(fieldMatcher[this.item.type]);
    this.componentRef = this.container.createComponent(factory);

    // forward events for table
    if (this.item.type === FieldTypes.Table) {
      if (this.item.tableCellChange !== undefined) {
        this.componentRef.instance.cellChange.subscribe($event => this.item.tableCellChange($event));
      }
      if (this.item.tableChange !== undefined) {
        this.componentRef.instance.dgChange.subscribe($event => this.item.tableChange($event));
      }
      if (this.item.tableClick !== undefined) {
        this.componentRef.instance.rowClick.subscribe($event => this.item.tableClick($event));
      }
      if (this.item.tableDblClick !== undefined) {
        this.componentRef.instance.dblClick.subscribe($event => this.item.tableDblClick($event));
      }
      if (this.item.tableSelectChange !== undefined) {
        this.componentRef.instance.selectChange.subscribe($event => this.item.tableSelectChange($event));
      }
      if (this.item.tableAddClick !== undefined) {
        this.componentRef.instance.addClick.subscribe($event => this.item.tableAddClick($event));
      }
      if (this.item.tableEditClick !== undefined) {
        this.componentRef.instance.editClick.subscribe($event => this.item.tableEditClick($event));
      }
      if (this.item.tableDeleteClick !== undefined) {
        this.componentRef.instance.deleteClick.subscribe($event => this.item.tableDeleteClick($event));
      }
    }
    // forward events for DropDown
    if (this.item.type === FieldTypes.DropDown) {
      if (this.item.onChangedFunc !== undefined) {
        this.componentRef.instance.onchange.subscribe($event => this.item.onChangedFunc($event));
      }
    }
    if (this.item.type === FieldTypes.AutoComplete) {
      if (this.item.onChangedFunc !== undefined) {
        this.componentRef.instance.onchange.subscribe($event => this.item.onChangedFunc($event));
      }
    }
    if (this.item.type === FieldTypes.File) {
      if (this.item.onChangedFunc !== undefined) {
        this.componentRef.instance.onchange.subscribe($event => this.item.onChangedFunc($event));
      }
    }
    // forward events for input icon
    if (this.componentRef.componentType.name === 'InputComponent') {
      if (this.item.iconClick !== undefined && this.item.icon) {
        this.componentRef.instance.onclick.subscribe($event => {
          this.itemClick.emit(this.item);
        });
      }
      if (this.item.onChangedFunc !== undefined) {
        this.componentRef.instance.onchange.subscribe($event => this.item.onChangedFunc($event));
      }
    }
    // forward events for button
    if (this.item.type === FieldTypes.Button) {
      if (this.item.iconClick !== undefined) {
        this.componentRef.instance.onclick.subscribe($event => {
          this.itemClick.emit(this.item);
        });
      }
    }

    // assign item and form
    this.componentRef.instance.item = this.item;
    this.componentRef.instance.form = this.form;
  }
}
